import { setupWorker, rest } from 'msw';
import { handleRequest } from './handler';

const routeToIntercept = `${
  process.env.VUE_APP_API_URL || 'https://api.gslc.com/'
}/*`;

export const worker = setupWorker(
  rest.get(routeToIntercept, handleRequest),
  rest.post(routeToIntercept, handleRequest),
  rest.patch(routeToIntercept, handleRequest),
  rest.put(routeToIntercept, handleRequest),
  rest.delete(routeToIntercept, handleRequest)
);
